import dsBridgeSDK from "../assets/js/dsBridge";

/**
 *  h5注册js方法供端上调用
 * @param {string} sendData h5返回给app的数据
 * @param {function} callback 回调方法,接收app传递的数据
 */

export const registerFnHandler = (name, callBack) => {
  dsBridgeSDK.registerLocalHandler(name, callBack);
};
